export default __webpack_public_path__ + "static/media/stepOneCat.4acf3645.png";